import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.components.CreditCardItemForm`

export default defineMessages({
  itemInformationTitle: {
    id: `${scope}.itemInformationTitle`,
    defaultMessage: 'Item information',
  },
  descriptionLabel: {
    id: `${scope}.descriptionLabel`,
    defaultMessage: 'Description',
  },
  descriptionPlaceholder: {
    id: `${scope}.descriptionPlaceholder`,
    defaultMessage: 'eg. Best Buy',
  },
  descriptionRequiredError: {
    id: `${scope}.descriptionRequiredError`,
    defaultMessage: 'Description is required',
  },
  dateLabel: {
    id: `${scope}.dateLabel`,
    defaultMessage: 'Date',
  },
  dateRequiredError: {
    id: `${scope}.dateRequiredError`,
    defaultMessage: 'Date is required',
  },
  amountLabel: {
    id: `${scope}.amountLabel`,
    defaultMessage: 'Amount',
  },
  amountPlaceholder: {
    id: `${scope}.amountPlaceholder`,
    defaultMessage: '0.00',
  },
  amountRequiredError: {
    id: `${scope}.amountRequiredError`,
    defaultMessage: 'Amount is required',
  },
  currencyLabel: {
    id: `${scope}.currencyLabel`,
    defaultMessage: 'Currency',
  },
  currencyRequiredError: {
    id: `${scope}.currencyRequiredError`,
    defaultMessage: 'Currency is required',
  },
  poTag: {
    id: `${scope}.poTag`,
    defaultMessage: 'PO',
  },
  rfeTag: {
    id: `${scope}.rfeTag`,
    defaultMessage: 'RFE',
  },
  totalCostLabel: {
    id: `${scope}.totalCostLabel`,
    defaultMessage: 'Total cost',
  },
  totalCostAriaLabel: {
    id: `${scope}.totalCostAriaLabel`,
    defaultMessage: 'Total cost',
  },
  attachmentsTitle: {
    id: `${scope}.attachmentsTitle`,
    defaultMessage: 'Attachments',
  },
  noFilesAttachedText: {
    id: `${scope}.noFilesAttachedText`,
    defaultMessage: 'No files attached (max file size 25.0 MB)',
  },
  fileTooLargeError: {
    id: `${scope}.fileTooLargeError`,
    defaultMessage: 'File exceeds the maximum size of 25.0 MB',
  },
  uploadButton: {
    id: `${scope}.uploadButton`,
    defaultMessage: 'Upload',
  },
  removeAttachmentAriaLabel: {
    id: `${scope}.removeAttachmentAriaLabel`,
    defaultMessage: 'Remove attachment {name}',
  },
  allocateToTitle: {
    id: `${scope}.allocateToTitle`,
    defaultMessage: 'Allocate to',
  },
  costColumnTitle: {
    id: `${scope}.costColumnTitle`,
    defaultMessage: 'Cost',
  },
  locationPlaceholder: {
    id: `${scope}.locationPlaceholder`,
    defaultMessage: 'Select a location',
  },
  locationAriaLabel: {
    id: `${scope}.locationAriaLabel`,
    defaultMessage: 'Allocation location',
  },
  departmentPlaceholder: {
    id: `${scope}.departmentPlaceholder`,
    defaultMessage: 'Select a department',
  },
  departmentAriaLabel: {
    id: `${scope}.departmentAriaLabel`,
    defaultMessage: 'Allocation department',
  },
  accountCodePlaceholder: {
    id: `${scope}.accountCodePlaceholder`,
    defaultMessage: 'Select an account code',
  },
  accountCodeAriaLabel: {
    id: `${scope}.accountCodeAriaLabel`,
    defaultMessage: 'Allocation account code',
  },
  allocationAmountAriaLabel: {
    id: `${scope}.allocationAmountAriaLabel`,
    defaultMessage: 'Allocation amount',
  },
  removeAllocationAriaLabel: {
    id: `${scope}.removeAllocationAriaLabel`,
    defaultMessage: 'Remove allocation',
  },
  addAccountCodeButton: {
    id: `${scope}.addAccountCodeButton`,
    defaultMessage: 'Add account code(s)',
  },
  totalEstimatedCostLabel: {
    id: `${scope}.totalEstimatedCostLabel`,
    defaultMessage: 'Total estimated cost',
  },
  unassignedCostLabel: {
    id: `${scope}.unassignedCostLabel`,
    defaultMessage: 'Unassigned cost',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
  saveButton: {
    id: `${scope}.saveButton`,
    defaultMessage: 'Save item',
  },
})
